module.exports = __webpack_public_path__ + "img/img_kakao.6cc0214a.png";